let $ = window.$

$(function() {
	$("#accordion-open").accordion({
		heightStyle: "content",
		active: "false",
		collapsible: "true"
	});
})
